import { combineReducers } from "redux";
import posts from './posts';

export default combineReducers({posts});
//since key and value both are equal to posts